import React from 'react'
import { ProcessNodeDefinitions, Parser } from 'html-to-react'

import * as customComponents from '../components/CustomComponents'
import { customModules } from '../modules/CustomModules'

import {
  parseJson,
  customModuleNameFromNode,
  entryIdFromNode,
  entryWithId,
  imageEntryToImage,
  parseCustomModuleName,
} from '.'

const processNodeDefinitions = new ProcessNodeDefinitions()

// node には rich text をプレ処理した text をパースしたものが格納されている
const processingInstructions = (data) => [
  // カスタムモジュール
  {
    shouldProcessNode: (node) => {
      const { moduleName, subModuleName } = parseCustomModuleName(
        customModuleNameFromNode(node)
      )
      return (
        moduleName &&
        customModules.hasOwnProperty(moduleName) &&
        (!subModuleName ||
          customModules[moduleName].hasOwnProperty(subModuleName))
      )
    },
    processNode: (node, children) => {
      const { moduleName, subModuleName } = parseCustomModuleName(
        customModuleNameFromNode(node)
      )
      const CustomModule = subModuleName
        ? customModules[moduleName][subModuleName]
        : customModules[moduleName]
      const entryId = entryIdFromNode(node)
      const entry = entryWithId(entryId, data)
      // contentful の JSON フィールドについて、値全体を取得するハック
      // https://github.com/gatsbyjs/gatsby/issues/14762#issuecomment-506084912
      const props = parseJson(entry.props?.internal?.content) ?? {}
      return (
        <CustomModule key={entry.contentful_id} {...props}>
          {children}
        </CustomModule>
      )
    },
  },
  // Image
  // props で width や height の指定があれば Contentful でリサイズし、通常の img タグとして表示
  {
    shouldProcessNode: (node) => customModuleNameFromNode(node) === 'Image',
    processNode: (node) => {
      const entryId = entryIdFromNode(node)
      const entry = entryWithId(entryId, data)
      const body = entry.body
      if (body === null) {
        // 多言語対応：対応言語の body がない場合
        return null
      }
      return imageEntryToImage(entry)
    },
  },
  // カスタムコンポーネント
  {
    shouldProcessNode: (node) => {
      const moduleName = customModuleNameFromNode(node)
      return moduleName && moduleName in customComponents
    },
    processNode: (node, children) => {
      const moduleName = customModuleNameFromNode(node)
      const CustomComponent = customComponents[moduleName]
      const entryId = entryIdFromNode(node)
      const entry = entryWithId(entryId, data)
      const props = parseJson(entry.props?.internal?.content) ?? {}
      return (
        <CustomComponent
          key={entry.contentful_id}
          data={data}
          entry={entry}
          {...props}
        >
          {children}
        </CustomComponent>
      )
    },
  },
  // Contentful Content Type: Element
  {
    shouldProcessNode: (node) => customModuleNameFromNode(node) === '',
    processNode: (_, children) => children,
  },
  // デフォルト処理
  {
    shouldProcessNode: () => true,
    processNode: processNodeDefinitions.processDefaultNode,
  },
]

const isValidNode = () => true

export const parseHtmlToReact = (html, data) => {
  // https://github.com/aknuds1/html-to-react
  const htmlToReactParser = new Parser()
  const instructions = processingInstructions(data)
  return htmlToReactParser.parseWithInstructions(
    html,
    isValidNode,
    instructions
  )
}
